var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotesLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 9,
    viewBox: "-17 0 130 0.3",
    "data-shape": "true",
    "aria-hidden": "true",
    id: "cs-pattern-right",
    stroke: "#4831d4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 0 0 a 7.891 7.891 0 1 1 -15.782 0 a 7.891 7.891 0 0 1 15.782 0 z m 28.069 0 a 7.892 7.892 0 1 1 -15.784 -0.002 a 7.892 7.892 0 0 1 15.784 0.002 z m 28.068 0 a 7.891 7.891 0 1 1 -15.782 0 a 7.891 7.891 0 0 1 15.783 0 z m 28.07 0 a 7.892 7.892 0 1 1 -15.783 -0.002 a 7.892 7.892 0 0 1 15.783 0.002 z m 28.068 0 a 7.891 7.891 0 1 1 -15.782 0 a 7.891 7.891 0 0 1 15.782 0 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotesLine);
export default __webpack_public_path__ + "static/media/dotes-line.fd3bbc83a5d444d6ffd559e2777d9999.svg";
export { ForwardRef as ReactComponent };